module.exports = __webpack_public_path__ + "static/media/not_found.08d169d6.png";